import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import {
  fetchAuthorizations,
  saveCredentials,
  deleteAuthorization,
} from '../../../../../actions/licensesAction';
import { AuthorizationCredentialItem } from './AuthorizationCredentialItem';
import { AuthorizationCredentialAdd } from './AuthorizationCredentialAdd';
import PlusIcon from '../../../../../images/plus.svg';

export const AuthorizationCredentialSection = ({
  allProfessions,
}) => {
  const dispatch = useDispatch();

  const userId = useSelector(
    (state) => state.users.currentUser?.id,
  );
  const authorizations = useSelector(
    (state) => state.users.authorizations,
  );
  const credentialRules = useSelector(
    (state) => state.users.credentialRules,
  );
  const isLoading = useSelector(
    (state) => state.users.authorizationsLoading,
  );

  const [expandedIds, setExpandedIds] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  useEffect(() => {
    if (userId) {
      dispatch(fetchAuthorizations(userId));
    }
  }, [dispatch, userId]);

  const handleToggle = (id) => {
    const isExpanded = expandedIds.includes(id);
    if (isExpanded) {
      setExpandedIds((prev) =>
        prev.filter((item) => item !== id),
      );
    } else {
      setExpandedIds((prev) => [...prev, id]);
    }
  };

  const handleDelete = (authorizationId) => {
    if (!userId || !authorizationId) return;
    dispatch(deleteAuthorization(userId, authorizationId));
  };

  const handleSave = (updatedAuth) => {
    if (!userId || !updatedAuth?.id) return Promise.resolve();

    // Save each credential via its respective API
    if (updatedAuth.credentials?.length) {
      return dispatch(
        saveCredentials(
          userId,
          updatedAuth.id,
          updatedAuth.credentials,
        ),
      );
    }
    return Promise.resolve();
  };

  const getRulesForAuth = (authorization) => {
    const rule = credentialRules?.find(
      (r) =>
        r.profession === authorization?.profession
        && r.state === authorization?.state,
    );
    return rule?.credentials || [];
  };

  const renderLoading = () => (
    <div
      style={{
        flex: 1,
        border: '1px solid #b7b7b7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 300,
      }}
    >
      <Spinner
        animation="border"
        role="status"
        variant="info"
        style={{
          height: 30,
          width: 30,
        }}
      />
    </div>
  );

  const renderEmpty = () => (
    <div
      style={{
        flex: 1,
        border: '1px solid #b7b7b7',
        borderTop: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 60,
      }}
    >
      <p style={{ textAlign: 'center', margin: 0 }}>
        No authorizations found
      </p>
    </div>
  );

  const renderItems = () => {
    if (isLoading) return renderLoading();
    if (!authorizations?.length) return renderEmpty();

    return authorizations.map((authorization) => (
      <AuthorizationCredentialItem
        key={authorization.id}
        authorization={authorization}
        isExpanded={expandedIds.includes(
          authorization.id,
        )}
        handleToggle={handleToggle}
        allProfessions={allProfessions}
        credentialRules={getRulesForAuth(authorization)}
        onSave={handleSave}
        onDelete={handleDelete}
      />
    ));
  };

  return (
    <>
      <h3>Professional Credentials</h3>

      <div
        style={{
          border: '1px solid #b7b7b7',
          padding: '16px 60px',
          display: 'flex',
          flexDirection: 'row',
          backgroundColor: '#ADD8E6',
        }}
      >
        <div style={{ flex: 1, fontWeight: '600' }}>
          Profession
        </div>
        <div style={{ flex: 1, fontWeight: '600' }}>
          State
        </div>
        <div style={{ flex: 1, fontWeight: '600' }}>
          Status
        </div>
        <div style={{ width: 24 }} />
      </div>

      {renderItems()}

      {showAddForm ? (
        <AuthorizationCredentialAdd
          onClose={() => setShowAddForm(false)}
        />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 40,
            marginBottom: 40,
          }}
        >
          <button
            className="btn btn-success"
            style={{ width: 100, height: 34 }}
            onClick={() => setShowAddForm(true)}
            type="button"
          >
            <img
              style={{ marginRight: 4 }}
              src={PlusIcon}
              alt="Plus icon"
            />
            License
          </button>
        </div>
      )}
    </>
  );
};
